document.addEventListener("DOMContentLoaded", (function () {
  const STYLE_ID = 'loop-override-styles';

  function applyLoopStyles() {
    const isActive = LoopOnstore.isActive();
    const existingStyle = document.getElementById(STYLE_ID);

    if (isActive) {
      if (!existingStyle) {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = `
          .checkout-buttons a[data-route-href*="/checkout"] {
            display: none !important;
          }
          #btn-loop-returns {
            display: block !important;
          }
        `;
        document.head.appendChild(style);
      }
    } else {
      if (existingStyle) {
        existingStyle.remove();
      }
    }
  }

  function waitForLoopOnstore(maxTries = 20, interval = 200) {
    let tries = 0;

    const check = () => {
      tries++;

      if (window.LoopOnstore && typeof LoopOnstore.isActive === 'function') {
        applyLoopStyles();
        return; // ¡Listo!
      }

      if (tries >= maxTries) {
        console.warn('LoopOnstore no se encontró, no se aplican estilos.');
        return;
      }

      setTimeout(check, interval);
    };

    check();
  }

  waitForLoopOnstore();
})());
